import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        onUpdate: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'user.Add skill' | translate }}</h2>
        </div>
        <form ng-submit="vm.save()" class="form">
            <div class="modal-body">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'user.Skill name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.name" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.description">
                        <label class="label">{{ 'user.Skill Description' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.description" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.parentSkillId">
                        <label class="label">{{ 'user.Parent skill' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.form.model.parentSkillId">
                                <option value=""></option>
                                <option value="{{ item.id }}" ng-repeat-start="item in vm.parentSkills">
                                   {{ item.name }}
                                </option>
                                <option value="{{ l2item.id }}" ng-repeat-start="l2item in item.children">
                                    &nbsp;&nbsp;{{ l2item.name }}
                                </option>
                                <option value="{{ l3item.id }}" ng-repeat-start="l3item in l2item.children">
                                    &nbsp;&nbsp;&nbsp;{{ l3item.name }}
                                </option>
                                <option value="{{ l4item.id }}" ng-repeat-start="l4item in l3item.children">
                                   &nbsp;&nbsp;&nbsp;&nbsp;{{ l4item.name }}
                                </option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                            </select>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.defaultUserSkillLevel">
                        <label class="label">{{ 'user.Default user skill level' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.defaultUserSkillLevel" type="text" class="form-control small">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </form-wrapper>
            </div>
            <div class="modal-footer" >
                    <ul class="actions01">
                        <li class="primary">
                            <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                        </li>
                        <li>
                            <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button>
                        </li>
                    </ul>
                </div>
        </form>
    `
})
export default class {
    constructor ($translate, FormFactory, SkillResource, CompanyResource, TokenService, MomentService, ModalService) {
        this.$translate = $translate;
        this.FormFactory = FormFactory;
        this.MomentService = MomentService;
        this.TokenService = TokenService;
        this.CompanyResource = CompanyResource;
        this.SkillResource = SkillResource;
        this.ModalService = ModalService;
    }

    $onInit () {
        this.SkillResource.tree().$promise.then((skills) => {
            this.parentSkills = skills;
        });
        this.CompanyResource.get({ id: this.TokenService.getCompanyId() }).$promise.then(company => {
            this.form = this.FormFactory.createFromResource(new this.SkillResource);
            this.form.model.defaultUserSkillLevel = company.defaultSkillLevel;
        });
    }

    save () {
        this.form.save().then(() => {
            this.onUpdate();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/skill/add/index.js